"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ResourceLogsQueryParams", {
    enumerable: true,
    get: function() {
        return ResourceLogsQueryParams;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _resourcelog = require("./resource-log");
const ResourceLogsQueryParams = _zod.z.object({
    resourceTypes: (0, _utilsisomorphic.transformStringToArray)(_resourcelog.ResourceLogResourceTypes).optional(),
    resourceIds: (0, _utilsisomorphic.transformStringToArray)(_utilsisomorphic.transformObjectId).optional(),
    resourceChangeTypes: (0, _utilsisomorphic.transformStringToArray)(_resourcelog.ResourceLogResourceChangeTypes).optional(),
    skip: _zod.z.string().optional().default("0"),
    limit: _zod.z.string().optional().default("10")
});
